import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ChipsTextField = styled(TextField)(() => ({
  "& input": {
    paddingLeft: "8px",
  },
}));
